import LaboratoryModel from "@/models/lab/LaboratoryModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class LaboratoryCollection extends LabServiceCollection {
  model() {
    return LaboratoryModel;
  }

}
